// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2N2_A","row":"Node_row__139Eq","label":"Node_label__113XV","footer":"Node_footer__d6cL4"};